import merchantApi from "@/api/merchant";
const merchant = {
  state: {
    merchantList: [],
    merchantTypes: [],
  },
  getters: {
    merchantList(state) {
      return state.merchantList.map((v) => {
        return {
          value: v.dcMerchantId,
          label: v.dcMerchantName,
        };
      });
    },
    merchantTypes(state) {
      return state.merchantTypes.map((v) => {
        return {
          value: v.value,
          label: v.name,
        };
      });
    },
  },
  mutations: {
    setMerchantList(state, data) {
      state.merchantList = data;
    },
    setMerchantTypes(state, data) {
      state.merchantTypes = data;
    },
  },
  actions: {
    fetchMerchantList({ commit }, data) {
      const modeFlag = data ? data : "0";
      return merchantApi.list({ cooperationModeFlag: modeFlag }).then((res) => {
        commit("setMerchantList", res.selectItemList);
        return res;
      });
    },
    fetchMerchantAuthorizeList({ commit }, data) {
      return merchantApi.merchantAuthorize(data);
    },
    fetchMerchantTypes({ commit }, data) {
      return merchantApi.merchantTypes().then((res) => {
        commit("setMerchantTypes", res.value);
      });
    },
    updateMerchantAuth({ commit }, data) {
      return merchantApi.updateMerchantAuth(data);
    },
    downloadMerchantAuth({ commit }, data) {
      return merchantApi.downloadMerchantAuth(data);
    },
    merchantBrandAuth({ commit }, data) {
      return merchantApi.merchantBrandAuth(data);
    },
    fetchMerchantSupplyPrice(_, data) {
      return merchantApi.supplyPrice(data).then((res) => {
        return res;
      });
    },
    previewImportChannelSupplyPrice(_, data) {
      return merchantApi.previewImportChannelSupplyPrice(data);
    },
    batchImportChannelSupplyPrice(_, data) {
      return merchantApi.batchImportChannelSupplyPrice(data);
    },
    spplyPriceQuery(_, data) {
      return merchantApi.spplyPriceQuery(data);
    },
    batchUpdateSupplyPrice(_, data) {
      return merchantApi.batchUpdateSupplyPrice(data);
    },
    downloadSupplyPriceTask(_, data) {
      return merchantApi.downloadSupplyPriceTask(data);
    },
  },
};

export default merchant;
